import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Cookies from "js-cookie";
import en from "./locales/en.json";
import vi from "./locales/vi.json";

const FALLBACK_LANG = "en";
const LANGUAGE_COOKIE = "lang";

const getBrowserLanguage = () => {
  if (typeof navigator === "undefined") return undefined;
  const preferred = [...(navigator.languages || []), navigator.language].find(
    (lang): lang is string => typeof lang === "string" && lang.length > 0,
  );
  if (!preferred) return undefined;
  return preferred.toLowerCase().startsWith("vi") ? "vi" : "en";
};

const getStoredLanguage = () => {
  try {
    return Cookies.get(LANGUAGE_COOKIE);
  } catch {
    return undefined;
  }
};

const preferredLanguage =
  getStoredLanguage() || getBrowserLanguage() || FALLBACK_LANG;

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    vi: { translation: vi },
  },
  lng: preferredLanguage,
  fallbackLng: FALLBACK_LANG,
  supportedLngs: ["en", "vi"],
  interpolation: { escapeValue: false },
});

export default i18n;

